import { render, staticRenderFns } from "./GeneralChannel.vue?vue&type=template&id=c7de9efa&"
import script from "./GeneralChannel.vue?vue&type=script&lang=js&"
export * from "./GeneralChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports